import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Box,
  Typography,
  Paper,
  Button,
  Stack,
  IconButton,
  Divider,
  Grid,
  TextField,
  Chip,
} from "@mui/material";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SaveIcon from "@mui/icons-material/Save";
import EditIcon from "@mui/icons-material/Edit";

/* ICONS */
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import CakeIcon from "@mui/icons-material/Cake";
import KitchenIcon from "@mui/icons-material/Kitchen";
import HomeIcon from "@mui/icons-material/Home";
import PublicIcon from "@mui/icons-material/Public";
import ImageIcon from "@mui/icons-material/Image";
import { Switch, FormControlLabel } from "@mui/material";
import {
  Backdrop,
  CircularProgress,
  Dialog,
  DialogContent,
  Snackbar,
  Alert,
} from "@mui/material";

/* DND */
import { DndContext, closestCenter } from "@dnd-kit/core";
import {
  SortableContext,
  useSortable,
  arrayMove,
  horizontalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

/* ================= PAGE ================= */

function EditRecipe() {
  const { t, i18n } = useTranslation(["Recettes"]);
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const userState = useSelector((state) => state.user);
  const { categoryId } = useParams();
  const [categories, setCategories] = useState([]);
  const isFrench = userState.lang === "FR";
  const lang = userState.lang || "FR";
  const [uploadProgress, setUploadProgress] = useState(0);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const videoUrlFr = `${process.env.REACT_APP_API_URL}/ManageVideoRecipe/PlayStreamVideo/${id}?lang=${"FR"}`;
  const videoUrlEn = `${process.env.REACT_APP_API_URL}/ManageVideoRecipe/PlayStreamVideo/${id}?lang=${"EN"}`;
  const [form, setForm] = useState({
    nomFr: "",
    nomEn: "",
    recetteFr: "",
    recetteEn: "",
    ingredientFr: "",
    ingredientEn: "",
    decorationFr: "",
    decorationEn: "",
    ustensileFr: "",
    ustensileEn: "",
    portionMinFr: "",
    portionMinEn: "",
    emporterFr: "",
    emporterEn: "",
    dateActivationDebut: "",
    dateActivationFin: "",
    estActif: true,
    hasVisibilityPeriod: false,
    image: null,
    imageUrl: null,
    imageRemoved: false,
    gallery: [],
    videoFr: null,
    videoEn: null,
    videoFrExists: false,
    videoEnExists: false,
    // 👇 AJOUT ICI
    videoFrRemoved: false,
    videoEnRemoved: false,
    removedGalleryIds: [],
    idRecetteCategorie: "",
  });

  const [errors, setErrors] = useState({});

  /* ================= HANDLERS ================= */
  const removeVideoFr = () => {
    setForm((prev) => ({
      ...prev,
      videoFr: null,
      /*videoFrExists: false,*/
      videoFrRemoved: true,
    }));
  };

  const removeVideoEn = () => {
    setForm((prev) => ({
      ...prev,
      videoEn: null,
      /*videoEnExists: false,*/
      videoEnRemoved: true,
    }));
  };
  const handleSwitch = (e) => {
    const { name, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleGallery = (e) => {
    const files = Array.from(e.target.files);

    const newItems = files.map((file) => ({
      id: `new-${crypto.randomUUID()}`,
      file,
      isNew: true,
    }));

    setForm((prev) => ({
      ...prev,
      gallery: [...prev.gallery, ...newItems],
    }));
  };

  const removeGalleryItem = (id) => {
    setForm((prev) => {
      const item = prev.gallery.find((x) => x.id === id);

      return {
        ...prev,
        gallery: prev.gallery.filter((x) => x.id !== id),

        // 👇 on garde trace des images supprimées côté backend
        removedGalleryIds: [
          ...(prev.removedGalleryIds || []),
          item?.dbId,
        ].filter(Boolean),
      };
    });
  };
  const handleMainImage = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setForm((prev) => ({
      ...prev,
      image: file,
      imageRemoved: false, // 🔥 intelligent
    }));

    e.target.value = null;
  };
  const handleVideo = (e) => {
    const { name, files } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: files[0],

      // RESET suppression si nouvelle vidéo ajoutée
      // 🔥 IMPORTANT: reset suppression
      ...(name === "videoFr" && {
        videoFrRemoved: prev.videoFrExists,
        videoFrExists: false,
      }),

      ...(name === "videoEn" && {
        videoEnRemoved: prev.videoEnExists,
        videoEnExists: false,
      }),
    }));
  };
  const selectedCategory = categories.find(
    (c) => String(c.id) === String(form.idRecetteCategorie),
  );
  /* ================= VALIDATION ================= */
  //to do

  //* ================= Get Recipe id  ================= */
  //to do

  /* ================= SUBMIT ================= */

  // 👇 AJOUT ICI (AVANT handleUpdate)
  const buildPayload = () => {
    return {
      id,

      nomFr: form.nomFr,
      nomEn: form.nomEn,

      recetteFr: form.recetteFr,
      recetteEn: form.recetteEn,

      ingredientFr: form.ingredientFr,
      ingredientEn: form.ingredientEn,

      decorationFr: form.decorationFr,
      decorationEn: form.decorationEn,

      ustensileFr: form.ustensileFr,
      ustensileEn: form.ustensileEn,

      portionMinFr: form.portionMinFr,
      portionMinEn: form.portionMinEn,

      emporterFr: form.emporterFr,
      emporterEn: form.emporterEn,

      estActif: form.estActif,
      hasVisibilityPeriod: form.hasVisibilityPeriod,

      dateActivationDebut: form.dateActivationDebut,
      dateActivationFin: form.dateActivationFin,

      removedGalleryIds: form.removedGalleryIds,

      newGallery: form.gallery.filter((x) => x.isNew).map((x) => x.file),

      existingGalleryOrder: form.gallery
        .filter((x) => !x.isNew)
        .map((x) => x.dbId),

      videoFrRemoved: form.videoFrRemoved,
      videoEnRemoved: form.videoEnRemoved,
      imageRemoved: form.imageRemoved,
    };
  };

  const handleUpdate = async () => {
    try {
      setLoading(true);

      const formData = new FormData();

      // =========================
      // 1. TEXT DATA
      // =========================

      formData.append("Id", id);

      formData.append("NomFr", form.nomFr || "");
      formData.append("NomEn", form.nomEn || "");

      formData.append("RecetteFr", form.recetteFr || "");
      formData.append("RecetteEn", form.recetteEn || "");

      formData.append("IngredientFr", form.ingredientFr || "");
      formData.append("IngredientEn", form.ingredientEn || "");

      formData.append("DecorationFr", form.decorationFr || "");
      formData.append("DecorationEn", form.decorationEn || "");

      formData.append("UstensileFr", form.ustensileFr || "");
      formData.append("UstensileEn", form.ustensileEn || "");

      formData.append("PortionMinFr", form.portionMinFr || "");
      formData.append("PortionMinEn", form.portionMinEn || "");

      formData.append("EmporterFr", form.emporterFr || "");
      formData.append("EmporterEn", form.emporterEn || "");

      formData.append("EstActif", form.estActif);
      formData.append("HasVisibilityPeriod", form.hasVisibilityPeriod);
      formData.append("IdRecetteCategorie", form.idRecetteCategorie);

      formData.append("DateActivationDebut", form.dateActivationDebut || "");

      formData.append("DateActivationFin", form.dateActivationFin || "");

      // =========================
      // 2. GALLERY IDS
      // =========================

      form.removedGalleryIds.forEach((id) => {
        formData.append("RemovedGalleryIds", id);
      });

      form.gallery
        .filter((x) => !x.isNew)
        .map((x) => x.dbId)
        .forEach((id) => {
          formData.append("ExistingGalleryOrder", id);
        });

      // =========================
      // 3. NEW GALLERY FILES
      // =========================

      form.gallery
        .filter((x) => x.isNew)
        .forEach((item) => {
          formData.append("NewGallery", item.file);
        });

      // =========================
      // 4. MAIN IMAGE
      // =========================

      if (form.image) {
        formData.append("Image", form.image);
      }

      formData.append("ImageRemoved", String(form.imageRemoved));

      // =========================
      // 5. VIDEOS
      // =========================

      if (form.videoFr) {
        formData.append("VideoFr", form.videoFr);
      }

      if (form.videoEn) {
        formData.append("VideoEn", form.videoEn);
      }

      formData.append("RemoveVideoFr", String(form.videoFrRemoved));

      formData.append("RemoveVideoEn", String(form.videoEnRemoved));

      // =========================
      // DEBUG
      // =========================

      console.log("FORMDATA READY 👉");

      for (let pair of formData.entries()) {
        console.log(pair[0], pair[1]);
      }
      const payload = buildPayload();
      console.log("JSON DEBUG 👉", payload);
      // =========================
      // API CALL
      // =========================

      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/ManageVideoRecipe/UpdateRecipe`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${userState.token}`,
          },
          body: formData,
        },
      );

      // DEBUG SERVER RESPONSE
      const responseText = await res.text();

      console.log("SERVER RESPONSE 👉", responseText);

      if (!res.ok) {
        throw new Error(responseText || "Update failed");
      }

      setSnackbar({
        open: true,
        message: "Recipe updated successfully",
        severity: "success",
      });

      setTimeout(() => navigate(-1), 1500);
    } catch (err) {
      console.error(err);

      setSnackbar({
        open: true,
        message: err.message || "Error updating recipe",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const handleUpdate2 = async () => {
    try {
      setLoading(true);

      const formData = new FormData();

      // =========================
      // 1. TEXT DATA
      // =========================
      const payload = buildPayload();

      console.log("JSON DEBUG 👉", payload);

      // =========================
      // 2. JSON FIELDS (important)
      // =========================
      form.removedGalleryIds.forEach((id) => {
        formData.append("RemovedGalleryIds", id);
      });

      formData.append(
        "existingGalleryOrder",
        JSON.stringify(form.gallery.filter((x) => !x.isNew).map((x) => x.dbId)),
      );

      // =========================
      // 3. FILES (GALLERY)
      // =========================
      form.gallery
        .filter((x) => x.isNew)
        .forEach((item) => {
          formData.append("NewGallery", item.file);
        });

      // =========================
      // 4. MAIN IMAGE
      // =========================
      if (form.image) {
        formData.append("Image", form.image);
      }
      formData.append("ImageRemoved", form.imageRemoved);
      // =========================
      // 5. VIDEOS
      // =========================
      if (form.videoFr) {
        formData.append("VideoFr", form.videoFr);
      }

      if (form.videoEn) {
        formData.append("VideoEn", form.videoEn);
      }

      formData.append("RemoveVideoFr", form.videoFrRemoved);
      formData.append("RemoveVideoEn", form.videoEnRemoved);

      // =========================
      // DEBUG
      // =========================
      console.log("FORMDATA READY 👉");
      for (let pair of formData.entries()) {
        console.log(pair[0], pair[1]);
      }

      // =========================
      // API CALL
      // =========================
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/ManageVideoRecipe/UpdateRecipe`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${userState.token}`,
            // ❌ NE PAS METTRE Content-Type !!
          },
          body: formData,
        },
      );

      if (!res.ok) throw new Error("Update failed");

      setSnackbar({
        open: true,
        message: "Recipe updated successfully",
        severity: "success",
      });

      setTimeout(() => navigate(-1), 1500);
    } catch (err) {
      console.error(err);

      setSnackbar({
        open: true,
        message: "Error updating recipe",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  /* ================= DND ================= */

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (!over) return;

    if (active.id !== over.id) {
      setForm((prev) => {
        const oldIndex = prev.gallery.findIndex((i) => i.id === active.id);
        const newIndex = prev.gallery.findIndex((i) => i.id === over.id);

        return {
          ...prev,
          gallery: arrayMove(prev.gallery, oldIndex, newIndex),
        };
      });
    }
  };

  useEffect(() => {
    console.log("imageRemoved 👉", form.imageRemoved);
  }, [form.imageRemoved]);

  const removeMainImage = () => {
    setForm((prev) => ({
      ...prev,
      image: null,
      imageUrl: null,
      imageRemoved: true,
    }));
  };
  useEffect(() => {
    fetchRecipe();
  }, [id]);

  useEffect(() => {
    return () => {
      if (form.image) {
        URL.revokeObjectURL(form.image);
      }
    };
  }, [form.image]);

  useEffect(() => {
    const loadCategories = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/CategoryRecipe/GetRecipeCategories`,
          {
            headers: {
              Authorization: `Bearer ${userState.token}`,
            },
          },
        );

        const data = await res.json();
        setCategories(data || []);
      } catch (err) {
        console.error(err);
        setCategories([]);
      }
    };

    if (userState.token) loadCategories();
  }, [userState.token]);

  const fetchRecipe = async () => {
    try {
      setLoading(true);
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/ManageVideoRecipe/GetRecipe/${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userState.token}`,
          },
        },
      );
      const data = await res.json();

      setForm((prev) => ({
        ...prev,

        nomFr: data.nomFr || "",
        nomEn: data.nomEn || "",

        recetteFr: data.recetteFr || "",
        recetteEn: data.recetteEn || "",

        ingredientFr: data.ingredientFr || "",
        ingredientEn: data.ingredientEn || "",

        decorationFr: data.decorationFr || "",
        decorationEn: data.decorationEn || "",

        ustensileFr: data.ustensileFr || "",
        ustensileEn: data.ustensileEn || "",

        portionMinFr: data.portionMinFr || "",
        portionMinEn: data.portionMinEn || "",

        emporterFr: data.emporterFr || "",
        emporterEn: data.emporterEn || "",

        dateActivationDebut: data.dateActivationDebut || "",
        dateActivationFin: data.dateActivationFin || "",

        estActif: data.estActif ?? true,
        hasVisibilityPeriod: data.hasVisibilityPeriod ?? false,

        // ⚠️ IMPORTANT : on ne met PAS de fichier ici
        image: null,
        imageUrl: data.imageUrl || null,
        imageRemoved: false,
        videoFr: null,
        videoEn: null,
        idRecetteCategorie: data.idRecetteCategorie || "",

        // 👉 stocker infos backend si besoin
        videoFrExists: data.videoFrExists,
        videoEnExists: data.videoEnExists,
        // ⭐ IMPORTANT ICI
        gallery: (data.galleryImages || []).map((img) => ({
          id: `db-${img.id}`,
          dbId: img.id,
          imageUrl: img.imageUrl,
          isNew: false,
        })),
      }));
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  /* ================= UI ================= */

  return (
    <Box sx={pageStyle}>
      <Paper sx={containerStyle}>
        {/* HEADER */}
        <Box sx={headerStyle}>
          <IconButton onClick={() => navigate(-1)}>
            <ArrowBackIcon />
          </IconButton>
          <Box display="flex" alignItems="center" gap={1}>
            <EditIcon fontSize="small" />
            <Typography fontSize={20} fontWeight={700}>
              {t("EditRecipe")}
            </Typography>
          </Box>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Chip
          label={
            selectedCategory
              ? `${selectedCategory.textFr} (${id})`
              : `Recette ${id}`
          }
        />
        <Box mt={2}>
          <Autocomplete
            options={categories}
            value={
              categories.find(
                (c) => String(c.id) === String(form.idRecetteCategorie),
              ) || null
            }
            onChange={(event, newValue) => {
              setForm((prev) => ({
                ...prev,
                idRecetteCategorie: newValue ? newValue.id : "",
              }));
            }}
            getOptionLabel={(option) =>
              isFrench ? option.textFr : option.textEn
            }
            isOptionEqualToValue={(option, value) => option.id === value.id}
            renderOption={(props, option) => (
              <li {...props}>
                <Box>
                  <strong>{isFrench ? option.textFr : option.textEn}</strong>
                  <div style={{ fontSize: 12, opacity: 0.6 }}>
                    ID: {option.id}
                  </div>
                </Box>
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label={isFrench ? "Catégorie de recette" : "Recipe category"}
                placeholder={
                  isFrench ? "Chercher une catégorie..." : "Search category..."
                }
              />
            )}
          />
        </Box>

        {/* section Status */}
        <Section title="Status" icon={<PublicIcon />}>
          {/* ACTIVE */}
          <FormControlLabel
            control={
              <Switch
                checked={form.estActif}
                onChange={handleSwitch}
                name="estActif"
              />
            }
            label={form.estActif ? "Recette active" : "Recette désactivée"}
          />

          {/* VISIBILITY */}
          <FormControlLabel
            control={
              <Switch
                checked={form.hasVisibilityPeriod}
                onChange={handleSwitch}
                name="hasVisibilityPeriod"
              />
            }
            label="Activer période de visibilité"
          />

          {/* DATES */}
          {form.hasVisibilityPeriod && (
            <Grid container spacing={2} mt={1}>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  type="datetime-local"
                  label="Date début"
                  name="dateActivationDebut"
                  value={form.dateActivationDebut}
                  onChange={handleChange}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  type="datetime-local"
                  label="Date fin"
                  name="dateActivationFin"
                  value={form.dateActivationFin}
                  onChange={handleChange}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          )}
        </Section>

        {/* NOM */}
        <Grid container spacing={2} mt={1}>
          <LangField name="nomFr" form={form} onChange={handleChange} />
          <LangField
            name="nomEn"
            form={form}
            onChange={handleChange}
            lang="EN"
          />
        </Grid>

        {/* RECETTE */}
        <Section title="Recette" icon={<RestaurantMenuIcon />}>
          <LangText name="recetteFr" form={form} onChange={handleChange} />
          <LangText
            name="recetteEn"
            form={form}
            onChange={handleChange}
            lang="EN"
          />
        </Section>

        {/* INGREDIENTS */}
        <Section title="Ingredients" icon={<ShoppingBasketIcon />}>
          <LangText name="ingredientFr" form={form} onChange={handleChange} />
          <LangText
            name="ingredientEn"
            form={form}
            onChange={handleChange}
            lang="EN"
          />
        </Section>

        {/* DECORATION */}
        <Section title="Decoration" icon={<CakeIcon />}>
          <LangText name="decorationFr" form={form} onChange={handleChange} />
          <LangText
            name="decorationEn"
            form={form}
            onChange={handleChange}
            lang="EN"
          />
        </Section>

        {/* USTENSILS */}
        <Section title="Utensils" icon={<KitchenIcon />}>
          <LangText name="ustensileFr" form={form} onChange={handleChange} />
          <LangText
            name="ustensileEn"
            form={form}
            onChange={handleChange}
            lang="EN"
          />
        </Section>

        {/* PORTION */}
        <Section title="Portion" icon={<HomeIcon />}>
          <LangField name="portionMinFr" form={form} onChange={handleChange} />
          <LangField
            name="portionMinEn"
            form={form}
            onChange={handleChange}
            lang="EN"
          />
        </Section>

        {/* PORTION */}
        <Section title="Takeaway" icon={<HomeIcon />}>
          <LangField name="emporterFr" form={form} onChange={handleChange} />
          <LangField
            name="emporterEn"
            form={form}
            onChange={handleChange}
            lang="EN"
          />
        </Section>

        {/* MEDIA */}
        <Section title="Media" icon={<ImageIcon />}>
          {/* MAIN IMAGE */}
          <Box sx={uploadBox}>
            <Typography fontWeight={600}>🖼 Image principale *</Typography>
            <Typography variant="caption" color="text.secondary">
              Image affichée comme couverture
            </Typography>

            <Button variant="outlined" component="label" sx={{ mt: 1 }}>
              Choisir une image
              <input
                hidden
                type="file"
                accept="image/*"
                onChange={handleMainImage}
              />
            </Button>

            {!form.imageRemoved && (form.imageUrl || form.image) && (
              <Box mt={1}>
                <Typography fontSize={12}>
                  ✔ {form.image ? form.image.name : "Image existante"}
                </Typography>

                <Box mt={1}>
                  <Box
                    sx={{
                      mt: 2,
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Box
                      sx={{
                        width: "100%",
                        maxWidth: 520,
                        height: 260,
                        borderRadius: 3,
                        overflow: "hidden",
                        background: "#f5f5f5",
                        border: "1px solid #e0e0e0",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
                      }}
                    >
                      <img
                        key={form.image ? form.image.name : form.imageUrl}
                        src={
                          form.image
                            ? URL.createObjectURL(form.image)
                            : form.imageUrl
                        }
                        alt="preview"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                          display: "block",
                        }}
                      />
                    </Box>
                  </Box>
                </Box>

                <Stack direction="row" spacing={1} mt={1}>
                  <Button color="error" onClick={removeMainImage}>
                    Supprimer
                  </Button>

                  <Button variant="outlined" component="label">
                    Remplacer
                    <input
                      hidden
                      type="file"
                      accept="image/*"
                      onChange={handleMainImage}
                    />
                  </Button>
                </Stack>
              </Box>
            )}
          </Box>

          {/* GALLERY */}
          <Box sx={uploadBox}>
            <Typography fontWeight={600}>
              🖼 Images supplémentaires ({form.gallery.length})
            </Typography>

            <Typography variant="caption" color="text.secondary">
              Ajoute plusieurs images • Glisse pour réorganiser
            </Typography>

            <Button variant="outlined" component="label" sx={{ mt: 1 }}>
              Ajouter des images
              <input
                hidden
                type="file"
                multiple
                accept="image/*"
                onChange={handleGallery}
              />
            </Button>

            <DndContext
              collisionDetection={closestCenter}
              onDragEnd={handleDragEnd}
            >
              <SortableContext
                items={form.gallery.map((i) => i.id ?? i)}
                strategy={horizontalListSortingStrategy}
              >
                <Box sx={galleryBox}>
                  {form.gallery.map((file, index) => (
                    <SortableItem
                      key={file.id}
                      id={file.id}
                      item={file}
                      onRemove={removeGalleryItem}
                    />
                  ))}
                </Box>
              </SortableContext>
            </DndContext>
          </Box>

          {/* VIDEO FR */}
          <Box sx={uploadBox}>
            <Typography fontWeight={600}>🎥 Vidéo Française</Typography>

            <Button variant="outlined" component="label" sx={{ mt: 1 }}>
              Ajouter vidéo FR
              <input
                hidden
                type="file"
                accept="video/*"
                name="videoFr"
                onChange={handleVideo}
              />
            </Button>

            {(form.videoFr || (form.videoFrExists && !form.videoFrRemoved)) && (
              <Box mt={1}>
                <Typography fontSize={12}>
                  ✔ {form.videoFr?.name || "Vidéo existante"}
                </Typography>

                <video controls width="100%" style={{ marginTop: 8 }}>
                  <source
                    src={
                      form.videoFr
                        ? URL.createObjectURL(form.videoFr)
                        : videoUrlFr
                    }
                    type="video/mp4"
                  />
                </video>

                <Button color="error" onClick={removeVideoFr}>
                  Supprimer vidéo
                </Button>
              </Box>
            )}
          </Box>

          {/* VIDEO EN */}
          <Box sx={uploadBox}>
            <Typography fontWeight={600}>🎥 English Video</Typography>

            <Button variant="outlined" component="label" sx={{ mt: 1 }}>
              Add EN video
              <input
                hidden
                type="file"
                accept="video/*"
                name="videoEn"
                onChange={handleVideo}
              />
            </Button>

            {(form.videoEn || (form.videoEnExists && !form.videoEnRemoved)) && (
              <Box mt={1}>
                <Typography fontSize={12}>
                  ✔ {form.videoEn?.name || "Video exists"}
                </Typography>

                <video controls width="100%" style={{ marginTop: 8 }}>
                  <source
                    src={
                      form.videoEn
                        ? URL.createObjectURL(form.videoEn)
                        : videoUrlEn
                    }
                    type="video/mp4"
                  />
                </video>

                <Button color="error" onClick={removeVideoEn}>
                  Delete video
                </Button>
              </Box>
            )}
          </Box>
        </Section>

        {/* PROGRESS */}
        {uploadProgress > 0 && (
          <Box mt={2}>
            <Typography>{uploadProgress}%</Typography>
            <Box sx={barBg}>
              <Box sx={{ ...barFill, width: `${uploadProgress}%` }} />
            </Box>
          </Box>
        )}

        {/* ACTION */}
        <Stack direction="row" justifyContent="flex-end" mt={3}>
          <Button
            variant="contained"
            startIcon={<SaveIcon />}
            onClick={handleUpdate}
            disabled={loading}
          >
            Save
          </Button>
        </Stack>
      </Paper>
      <Backdrop
        open={loading}
        sx={{ zIndex: 9999, color: "#fff", backgroundColor: "rgba(0,0,0,0.6)" }}
      >
        <Box textAlign="center">
          <CircularProgress color="inherit" />

          <Typography mt={2}>
            {isFrench ? "Enregistrement en cours..." : "Saving recipe..."}
          </Typography>
        </Box>
      </Backdrop>
      <Dialog open={success}>
        <DialogContent sx={{ textAlign: "center", p: 4 }}>
          <Typography variant="h5">
            🎉 {isFrench ? "Succès" : "Success"}
          </Typography>

          <Typography mt={2}>{snackbar.message}</Typography>
        </DialogContent>
      </Dialog>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity={snackbar.severity} variant="filled">
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

/* ================= LANG COMPONENTS ================= */
const uploadBox = {
  p: 2,
  mt: 2,
  border: "1px dashed #ccc",
  borderRadius: 2,
  background: "#fafafa",
};
const langBadgeStyle = (lang) => ({
  position: "absolute",
  top: -10,
  left: 10,
  fontSize: 11,
  fontWeight: 700,
  padding: "3px 8px",
  borderRadius: 8,
  background: lang === "FR" ? "#1976d2" : "#2e7d32",
  color: "#fff",
  boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
});

const LangField = ({ label, name, form, onChange, lang = "FR" }) => (
  <Grid item xs={12} md={6}>
    <Box sx={{ position: "relative", mt: 2 }}>
      <Box sx={langBadgeStyle(lang)}>{lang}</Box>
      <TextField
        fullWidth
        label={label}
        name={name}
        value={form[name]}
        onChange={onChange}
      />
    </Box>
  </Grid>
);

const LangText = ({ name, form, onChange, lang = "FR" }) => (
  <Box sx={{ position: "relative", mt: 2 }}>
    <Box sx={langBadgeStyle(lang)}>{lang}</Box>
    <TextField
      fullWidth
      multiline
      minRows={3}
      name={name}
      value={form[name]}
      onChange={onChange}
    />
  </Box>
);

/* ================= SORTABLE ================= */

function SortableItem({ id, item, onRemove }) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  const src = item.file ? URL.createObjectURL(item.file) : item.imageUrl;

  return (
    <Box
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      sx={{
        ...thumb,
        transform: CSS.Transform.toString(transform),
        transition,
      }}
    >
      <img src={src} style={img} />

      <Button
        onPointerDown={(e) => e.stopPropagation()}
        onClick={(e) => {
          e.stopPropagation();
          onRemove(id);
        }}
        sx={deleteBtn}
      >
        ✕
      </Button>
    </Box>
  );
}

/* ================= SECTION ================= */

function Section({ title, icon, children }) {
  return (
    <Paper sx={sectionStyle}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        {icon}
        <Typography fontWeight={700}>{title}</Typography>
      </Box>
      <Divider sx={{ my: 1 }} />
      {children}
    </Paper>
  );
}

/* ================= STYLES ================= */

const pageStyle = { minHeight: "100vh", background: "#f4f6f8", p: 2 };

const containerStyle = { maxWidth: 1000, mx: "auto", p: 3 };

const sectionStyle = { p: 2, mt: 2, background: "#fff", borderRadius: 3 };

const galleryBox = { display: "flex", gap: 1, mt: 2, flexWrap: "wrap" };

const thumb = { width: 80, height: 80, position: "relative", cursor: "grab" };

const img = { width: "100%", height: "100%", objectFit: "cover" };

const deleteBtn = { position: "absolute", top: 0, right: 0, minWidth: 0 };

const barBg = { height: 6, background: "#eee", borderRadius: 5 };

const barFill = { height: "100%", background: "#1976d2" };

const headerStyle = { display: "flex", alignItems: "center", gap: 1 };

export default EditRecipe;
